<div class="slide-toggle-container" [ngClass]="[containerCss, activeBold ? 'bold-mode' : '']">
  <label class="left-toggle-option" [ngClass]="[labelCss, !control.value && activeBold ? 'bold' : '']">
    {{ attrLeftLabel }}
  </label>
  <mat-slide-toggle [disableRipple]="disableRipple" [matTooltip]="tooltip" [formControl]="control" color="primary">
    <label [ngClass]="[labelCss, control.value && activeBold ? 'bold' : '']">{{ attrRightLabel }}</label>
  </mat-slide-toggle>
</div>
